import type { UserList } from 'models';
import { Button, Card, Icon } from 'ui';
import { IconDirectMessageButton } from 'features/chat';
import { UserAvatarPopover } from '../user-avatar-popover';

type P = {
  isLoading: boolean;
  onClick: () => void;
  title: string;
  users: UserList[];
  usersTotal: number;
};

const UsersHorizontalScrollCard = ({ isLoading, onClick, title, users, usersTotal }: P) => (
  <Card
    extra={
      usersTotal > 10 ? (
        <Button onClick={onClick} type="link-primary">
          See all
        </Button>
      ) : undefined
    }
    title={<Card.Title icon={<Icon icon="group-line" />}>{title}</Card.Title>}
  >
    {isLoading ? (
      <Card.HorizontalScroll.EntitySkeleton />
    ) : (
      <Card.HorizontalScroll
        items={users.map((user) => ({
          children: <UserAvatarPopover extra={<IconDirectMessageButton legacyUserId={user.id} />} user={user} />,
          key: user.id,
        }))}
      />
    )}
  </Card>
);

export default UsersHorizontalScrollCard;
